import Height from "./Height";
import Weight from "./Weight";
import BaseQuestionnaireFormData from "../BaseQuestionnaireFormData";
import {
    ACTIVITY_LEVEL,
    ALLERGY,
    DIETARY_PREFERENCE, FOOD_DISLIKE_EAT, FOOD_OFTEN_EAT,
    HEALTH_CONCERNS,
    MEAL_COUNT,
    RESULTS_TIMING,
    SKIN_CHANGES
} from "../../../const/FastingQuestionnaire";

const FASTING_QUESTIONNAIRE_CONSTANTS = {
    ACTIVITY_LEVEL,
    ALLERGY,
    DIETARY_PREFERENCE,
    FOOD_DISLIKE_EAT,
    FOOD_OFTEN_EAT,
    HEALTH_CONCERNS,
    MEAL_COUNT,
    RESULTS_TIMING,
    SKIN_CHANGES
};

const FASTING_ADDITIONAL_FIELDS = {
    heardFasting: "",
    whatFasting: "",
    mainGoalChoice: "",
    fastingSolution: "",
    habits: "",
    cravingsSupport: "",
    skinChanges: [],
    stayYouthful: ""
};

export class FastingFormData extends BaseQuestionnaireFormData {
    constructor() {
        super({
            HeightModel: Height,
            WeightModel: Weight,
            questionnaireConstants: FASTING_QUESTIONNAIRE_CONSTANTS,
            additionalFields: FASTING_ADDITIONAL_FIELDS,
            mainGoal: "weight_loss",
            mainGoalCode: 0,
            mainGoalLokalise: "Lose weight",
            workoutName: "fasting",
            mode: "fasting"
        });
    }
}

export default FastingFormData;
